import { html, css } from "lit";
import { customElement, property, query, queryAll } from "lit/decorators.js";
import { msg } from "@omegagrid/localize";
import { ContextIndicator } from "@reporting/rp-types/analytics";
import { Input, OmegaComponent, events } from "@omegagrid/core";

@customElement('rp-fsection-indicators-formula')
export class IndicatorFormulaSection extends OmegaComponent {

	static styles = [OmegaComponent.styles, css`
		.row {
			height: 100%;
			display: flex;
			flex-direction: row;
			align-items: center;
		}

		og-icon {
			flex: 0 0 15px;
		}

		og-input {
			flex: 1;
			width: 100%;
			border: 1px solid var(--og-colortype-accent-border-color);
		}
	`];

	@property({type: Object})
	indicator: ContextIndicator;

	@query('og-input')
	input: Input;

	updateIndicator() {
		this.indicator.formula = this.input.value;
		this.dispatchEvent(new events.ChangeEvent({value: this.indicator}));
	}

	render = () => this.indicator ? html`
		<div class="row">
			<og-icon icon="calculator"></og-icon>
			<og-input
				.value="${this.indicator.formula || ''}"
				@change="${() => this.updateIndicator()}">
			</og-input>
		</div>
	` : '';

	layout = () => {

	}

}
